import type { ReactNode } from 'react'
import { createContext, useState } from 'react'

type NestedLinks = {
  currentActiveListId?: string | number
  openList: (id: string | number) => void
  closeList: () => void
}

export const NestedLinksContext = createContext<NestedLinks | null>(null)

export const NestedLinksProvider = ({ children }: { children: ReactNode }) => {
  const [currentActiveListId, setCurrentActiveListId] = useState<
    string | number | undefined
  >()

  const openList = (id: string | number) => setCurrentActiveListId(id)
  const closeList = () => setCurrentActiveListId(undefined)

  return (
    <NestedLinksContext.Provider
      value={{ currentActiveListId, openList, closeList }}
    >
      {children}
    </NestedLinksContext.Provider>
  )
}
